import { ITransactionFees } from './../../../types/model.types';
import type { RootStore } from '~/stores/root.store';
import {
    TActiveFilesWithRecurring,
    TPaymentsHash
} from '~/components/Payments/components/types/payments.types';

export class PaymentsService {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    async toggleCardOnFile(isEnable: boolean): Promise<boolean> {
        const { userStore, apiService } = this.rootStore;
        const accountId = userStore.currUser.account_id;
        const response = await apiService.apiRequest<boolean>({
            method: 'put',
            url: `/api/v2/account/${accountId}/settings/card_on_file`,
            data: {
                is_card_on_file: isEnable
            }
        });
        return response;
    }

    async getTransactionFees(): Promise<ITransactionFees> {
        const { userStore, apiService } = this.rootStore;
        const accountId = userStore.currUser.account_id;
        const response = await apiService.apiRequest<ITransactionFees>({
            method: 'get',
            url: `/api/v2/account/${accountId}/transaction_fees`
        });
        return response;
    }

    async fetchNumberOfActiveRecurringFiles(): Promise<TActiveFilesWithRecurring> {
        const { userStore, apiService } = this.rootStore;
        const accountId = userStore.currUser.account_id;
        const response = await apiService.apiRequest<TActiveFilesWithRecurring>(
            {
                method: 'get',
                url: `/api/v2/account/${accountId}/active_recurring_payment_files`
            }
        );
        return response;
    }

    async fetchPayments(firstDay, lastDay, specificStatus) {
        const { userStore, apiService } = this.rootStore;
        const userId = userStore.currUser._id;
        const response = await apiService.apiRequest<TPaymentsHash>({
            method: 'get',
            url: `/api/v2/users/${userId}/reports/payments`,
            params: {
                from_date: firstDay,
                to_date: lastDay,
                specific_status: specificStatus
            }
        });
        return response;
    }

    async fetchYearlyPaymentsSum() {
        const { companyStore, apiService } = this.rootStore;
        const companyId = companyStore.currCompany._id;
        const response = await apiService.apiRequest({
            method: 'get',
            url: `/api/v2/reporting/companies/${companyId}/reports/bookings`
        });
        return response;
    }
}
